module.exports = __webpack_public_path__ + "files/c0687179bfe6b57428bb0eb4a164d4bd.png";